import { inject, Injectable } from '@angular/core';

import { map } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type { DeprecatedIntelligenceSettings } from './intelligence-settings.store';

@Injectable({ providedIn: 'root' })
export class DeprecatedIntelligenceSettingsHttpClient {
  private readonly http = inject(HttpApiService);

  public fetch() {
    return this.http
      .get(`/intelligence/settings`)
      .pipe(map((response): DeprecatedIntelligenceSettings => response.companySettings));
  }

  public update(companySettings: Partial<DeprecatedIntelligenceSettings>) {
    return this.http
      .patch(`/intelligence/settings`, null, { companySettings })
      .pipe(map((response): DeprecatedIntelligenceSettings => response.companySettings));
  }
}
